var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"tenso-logo"},[_vm._v(" Tenso ")])
}
var staticRenderFns = []

export { render, staticRenderFns }